<ng-container *transloco="let t">
    <div class="header-wrapper d-flex w-100" [style.background-color]="backgroundColor" [style.color]="color">
        <div [ngClass]="isMobile ? '' : 'container'" class="d-flex align-items-center justify-content-start w-100" (click)="goBack()">
                <button type="button" class="btn-back" aria-label="Close" [style.color]="color">
                    <i class="bi bi-chevron-left"></i>
                </button>
                 <div class="w-100 d-flex">
                     @if (!hideDefault) {
                     <p class="ps-2">{{ (t(key) | uppercase) }}</p>
                     }
                     @else {
                     <ng-content select="[slot='headerContent']"></ng-content>
                     }
                 </div>
        </div>
    </div>
</ng-container>
